import React, { useContext } from "react";
import styles from "./styles.module.css";
import logo from "../../Assets/images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { generateYupSchema } from "../../App/Helpers/ValidationSchema/validator.js";
import { UsersApi } from "../../App/api/users.api.js";
import { toast } from "react-toastify";
import LoaderContext from "../loader/LoaderContext.js";

function ForgetPassword({meta}) {
  const navigate = useNavigate();
  const { handleLoading } = useContext(LoaderContext);

  const initialValues = {
    email: "",
  };

  const { handleChange, values, handleSubmit, errors, handleBlur, touched } =
    useFormik({
      initialValues: initialValues,
      validationSchema: generateYupSchema(initialValues),
      onSubmit: async (value) => {
        handleLoading(true);
        const payload = {
          emailOrPhone: values.email,
        };
        try {
          const res = await UsersApi.generateOtp(payload);
          toast.success("OTP sent successfully");
            navigate("/verfy-otp", {
              state: { emailOrPhone: payload?.emailOrPhone },
            });
          handleLoading(false);
        } catch (err) {
          // console.log(err);
          toast.error(err?.message);
          handleLoading(false);
        }
      },
    });

  const handleBackToLogin = () => {
    navigate("/");
  };

  return (
    <div className={styles.container}>
      <div className={styles.loginHeader}>
        <p className={styles.heading}>Welcome to eDelivery Admin Panel</p>
      </div>
      <div className={styles.loginForm}>
        <Link className={styles.logo} to="#">
          <img src={logo} alt="logo" width="100px" height="100px"></img>
        </Link>
        <h4 className={styles.formH}>Forget Password</h4>
        <form onSubmit={handleSubmit} className={styles.Loginform}>
          <div className={styles.inputWrapper}>
            <label className={styles.label} htmlFor="email">
              Email
            </label>
            {errors.email && touched.email ? (
              <p
                style={{ paddingLeft: "0", paddingBlock: ".875rem" }}
                className="ess-form-error"
              >
                {" "}
                {errors.email}{" "}
              </p>
            ) : null}
            <input
              className={styles.input}
              id="email"
              name="email"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.email}
              placeholder="Username"
              type="email"
            />
          </div>

          <div className={styles.buttonWrapper}>
            <p className={styles.label} onClick={handleBackToLogin}>
              Login
            </p>
            <button className={styles.button}>Send OTP</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ForgetPassword;
